export default __webpack_public_path__ + "static/media/collagen@2x.a1421700.jpg";